import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface DeleteSavedBrandsDialogProps {
  open: boolean;
  handleClose?: () => void;
  handleConfirm: (deleteSavedBrands: boolean) => void;
  loading?: boolean;
}

export default function DeleteSavedBrandsDialog({
  open,
  handleClose,
  loading,
  handleConfirm,
}: DeleteSavedBrandsDialogProps) {
  const [deleteSavedBrands, setDeleteSavedBrands] = useState(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        Delete saved brands?{" "}
        <Box component="i" className="fa-solid fa-octagon-exclamation" />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Should we exclude these brands from future automated email scheduling?
        </Typography>
        <RadioGroup
          value={String(deleteSavedBrands)}
          onChange={(e) => setDeleteSavedBrands(e.target.value === "true")}
        >
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="Yes, exclude them"
          />
          <FormControlLabel
            value="true"
            control={<Radio />}
            label="No, allow them to be scheduled again"
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <LoadingButton
          loading={loading}
          onClick={() => handleConfirm(deleteSavedBrands)}
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
